import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDashboardNav } from '../context/DashboardNavContext';
import {
  isSubcontractorOnlyShell,
  employerIsMainUser,
  employerHasPermission,
  showEmployerSubcontractorDashboardSwitch,
} from '../utils/userDashboardUi';

/**
 * While on /profile (or profile-era invite onboarding), mirror employer/subcontractor shell nav in the header.
 */
export function useProfileShellDashboardNav(user) {
  const navigate = useNavigate();
  const { setDashboardNav, clearDashboardNav } = useDashboardNav();

  useEffect(() => {
    if (!user) {
      clearDashboardNav();
      return undefined;
    }

    if (isSubcontractorOnlyShell(user)) {
      const items = [
        {
          id: 'payments',
          label: 'Payments',
          active: false,
          onActivate: () => navigate('/dashboard/subcontractor?menu=payments'),
        },
        {
          id: 'employers',
          label: 'Employers',
          active: false,
          onActivate: () => navigate('/dashboard/subcontractor?menu=employers'),
        },
      ];
      setDashboardNav(items);
      return () => clearDashboardNav();
    }

    if (
      showEmployerSubcontractorDashboardSwitch(user) &&
      String(user.current_role || '').toLowerCase() === 'subcontractor'
    ) {
      const items = [
        {
          id: 'payments',
          label: 'Payments',
          active: false,
          onActivate: () => navigate('/dashboard/subcontractor?menu=payments'),
        },
        {
          id: 'employers',
          label: 'Employers',
          active: false,
          onActivate: () => navigate('/dashboard/subcontractor?menu=employers'),
        },
      ];
      setDashboardNav(items);
      return () => clearDashboardNav();
    }

    const items = [];
    if (employerIsMainUser(user) || employerHasPermission(user, 'view_subcontractors')) {
      items.push({
        id: 'subcontractors',
        label: 'Subcontractors',
        active: false,
        onActivate: () => navigate('/dashboard/employer?menu=subcontractors'),
      });
    }
    if (employerHasPermission(user, 'view_payments')) {
      items.push({
        id: 'payments',
        label: 'Payments',
        active: false,
        onActivate: () => navigate('/dashboard/employer?menu=payments'),
      });
    }
    if (employerIsMainUser(user)) {
      items.push({
        id: 'cis-returns',
        label: 'CIS Returns',
        active: false,
        onActivate: () => navigate('/dashboard/employer?menu=cis-returns'),
      });
    }

    if (items.length > 0) {
      setDashboardNav(items);
    } else {
      clearDashboardNav();
    }
    return () => clearDashboardNav();
  }, [user, navigate, setDashboardNav, clearDashboardNav]);
}
